import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { ICertificate } from '../interface/ICertificate';
import { IPerson } from '../interface/IPerson';
import { IOrder } from '../interface/IOrder';

const GetUrl = () => {
    switch (window.location.host) {
        case 'https://localhost:49196/':
            // return 'https://www.ticketspulse.ru/';
            return 'https://test.ticketspulse.ru/';
        case 'ticketspulse.ru':
            return 'https://test.ticketspulse.ru/';
        case 'https://192.168.4.13:49196':
            return 'https://test.ticketspulse.ru/';
        default:
            return 'https://test.ticketspulse.ru/';
    }
}
export const CallTPApi = createApi({
    reducerPath: 'callTPApi',
    baseQuery: fetchBaseQuery({
        baseUrl: GetUrl(),
        // baseUrl: 'https://www.ticketspulse.ru:30443/',
        // baseUrl: 'http://localhost:5077/',
        prepareHeaders: (headers, { getState }: { getState: any }) => {
            const token = getState().tokenTP?.value as any;
            const tokenAuthentication = getState().tokenAuthenticationTP?.value as any;
            // const tenantId = getState().tenant?.id as any;
            //Test
            const tenantId = "ddf7ee08-19e0-4a0a-b953-64eb2f9b43f8"
            //Prod
            // const tenantId = "621da32c-a4a9-400f-be33-73fdcc20e12f"

            headers.set("Authorization", `Bearer ${token || tokenAuthentication}`);
            { tenantId && headers.set("X-TenantId", `${tenantId}`) };
            // headers.set("X-TenantId", `${tenantId}`);
            return headers;
        },
    }),
    keepUnusedDataFor: 0,
    // global configuration for the api
    refetchOnMountOrArgChange: 0,
    endpoints: (builder) => ({
        postLogin: builder.mutation<any, any>({ query: (body) => ({ url: 'auth/login', method: 'POST', body }) }),
        postSetOrderStatus: builder.mutation<any, any>({ query: (formData: any) => ({ url: `/api/orders/${formData.id}/setstatus`, method: 'POST', body: formData.status }) }),
        postUserToken: builder.mutation<any, any>({ query: () => ({ url: 'api/UserToken/authorize', method: 'POST' }) }),
        postRegisterPhone: builder.mutation<any, any>({ query: (body) => ({ url: 'auth/registerphone', method: 'POST', body }) }),
        postSmsLogin: builder.mutation<any, any>({ query: (body) => ({ url: 'auth/smslogin', method: 'POST', body }) }),
        getPersonWhoami: builder.query<any, void>({ query: () => ({ url: 'api/persons/whoami', method: 'GET' }) }),
        getPersonWhoamiData: builder.mutation<any, void>({ query: () => ({ url: 'api/persons/whoami', method: 'GET' }) }),
        postOrder: builder.mutation<any, any>({ query: (formData: any) => ({ url: `/api/orders`, method: 'POST', body: formData }) }),
        getOrder: builder.mutation<any, any>({ query: (id: string) => ({ url: `/api/orders/${id}`, method: 'GET' }) }),
        putOrder: builder.mutation<any, any>({ query: (formData: any) => ({ url: `/api/orders/${formData.id}`, method: 'PUT', body: formData }) }),
        postOrderItem: builder.mutation<any, any>({ query: (formData: any) => ({ url: `/api/orderitems`, method: 'POST', body: formData }) }),
        postOrderBankLink: builder.mutation<any, any>({ query: (body: any) => ({ url: `/api/orders/${body.id}/banklink`, method: 'POST', responseHandler: (response) => response.text(), body: body }) }),
        postCertificate: builder.mutation<any, ICertificate | null>({ query: (body) => ({ url: `/api/certificates`, body: body, method: 'POST' }) }),
        putPerson: builder.mutation<any, IPerson>({ query: (body: IPerson) => ({ url: `/api/persons/${body.id}`, method: 'PUT', body }) }),
    }),
})

export const {
    usePostLoginMutation,
    usePostUserTokenMutation,
    usePostRegisterPhoneMutation,
    usePostSmsLoginMutation,
    useGetPersonWhoamiQuery,
    useGetPersonWhoamiDataMutation,
    usePostOrderMutation,
    usePutOrderMutation,
    usePostOrderItemMutation,
    usePostOrderBankLinkMutation,
    usePostCertificateMutation,
    usePutPersonMutation,
    usePostSetOrderStatusMutation,
    useGetOrderMutation,
} = CallTPApi